import React from 'react'

const CrossButton = ({className, onClick, children, style, type}) => {
  return (
    <><button className={className} style={style} onClick={onClick} type={type}>{children}</button></>
  )
}

export default CrossButton


